import { action, computed, observable, runInAction } from 'mobx'

import { adaptGetStripeDashboardUrlResponse, adaptGetStripeOnboardingStatusResponse, adaptGetStripeOnboardingUrlResponse } from 'supplier/adapters/payments'
import { getStripeDashboardUrl, getStripeOnboardingStatus, getStripeOnboardingUrl } from 'supplier/api/payments'

export const StripeStatus = Object.freeze({
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  VERIFIED: 'verified',
  PAST_DUE: 'past_due',
  CURRENTLY_DUE: 'currently_due',
})

class StripeOnboardingStore {
  /** @type {import('../root').RootStore} */
  root

  @observable verificationStatus = undefined
  @observable dueDate = new Date('2026-07-01T11:10:00Z')

  /**
   * @param {import('../root').RootStore} root
   */
  constructor (root) {
    this.root = root
  }

  @computed get isPaypalEmailProvided () {
    return !!this.root.paymentSettingsStore.paypalSettingsStore.paypalEmail
  }

  @computed
  get isVerified () {
    return this.verificationStatus === StripeStatus.VERIFIED
  }

  @computed
  get isAfterDueDate () {
    return new Date() > this.dueDate
  }

  @action
  async fetch () {
    const resp = await getStripeOnboardingStatus()
    const { verificationStatus } = adaptGetStripeOnboardingStatusResponse(resp.data)
    runInAction(() => {
      this.verificationStatus = verificationStatus
    })
  }

  async getOnboardingUrl () {
    const resp = await getStripeOnboardingUrl()
    const { onboardingUrl } = adaptGetStripeOnboardingUrlResponse(resp.data)
    return onboardingUrl
  }

  async getDashboardUrl () {
    const resp = await getStripeDashboardUrl()
    const { dashboardUrl } = adaptGetStripeDashboardUrlResponse(resp.data)
    return dashboardUrl
  }

  @action.bound
  reset () {
    this.verificationStatus = undefined
  }
}

export default StripeOnboardingStore
